exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sticky-menu .v-list[data-v-9481e6c8] {\n  display: flex;\n  flex-direction: column;\n}\n.sticky-menu .v-list-item--sticky[data-v-9481e6c8] {\n  position: sticky;\n  bottom: 0;\n  background: white;\n  z-index: 1;\n}\n.sticky-add-new[data-v-9481e6c8] {\n  position: sticky;\n  bottom: -7px;\n  background-color: white;\n  z-index: 1;\n}\n", ""]);

// exports
